import { reactive, ref, computed } from '@vue/composition-api'
import store from '@/store'
import * as common from '@/util/common'
import * as apiProfile from '@/api/profile'

/**
 * 背景画像の変更
 */
export const getGroup = (props, context) => {

  const group1 = reactive({

    // 現在選択されているテンプレート番号
    template: 0,

    // 選択できる背景リスト
    backgroundList: common.getTemplateImageList(),

    /**
     * 初期表示
     */
    init: () => {

      if (store.state.profile.template) {
        group1.template = store.state.profile.template
      } else {
        // 背景画像が未設定の場合はデフォルトを設定
        group1.template = 4
      }

    },

    /**
     * 画像を押下した場合
     */
    onImageClicked: (template) => {

      group1.template = template
    },

    /**
     * 設定ボタンを押下した場合
     */
    onSubmitButtonClicked: () => {

      // プロフィール更新APIをコール
      const params = {}
      params.template = group1.template

      apiProfile.update(params)
        .then(response => {
          if (response) {
            store.dispatch('profile/setTemplate', group1.template)
            context.emit('closeProfileChangeBackground')
          }
        })
    }

  })

  return group1
}
